<template>
  <el-dialog
    title="打印预览"
    v-if="payChargePrintPreShowDialogFlag"
    :visible.sync="payChargePrintPreShowDialogFlag"
    :modal-append-to-body="false"
    width="64%"
    @closed="handleClose"
  >
    <div class="el-property-dialog-div">
      <avue-form
        v-if="payChargePrintPreShowDialogFlag"
        v-model="payChargePrintPreForm"
        :option="payChargePrintPreOption"
        ref="payChargePrintPreFormRef"
        @submit="printSave"
        @click="saveF5"
      >
        <template slot-scope="scope" slot="menuForm">
          <!--<el-button type="primary" @click="printSave">保存</el-button>-->
          <el-button type="danger" @click="print('rule')">打印</el-button>
          <el-button type="danger" @click="print('fast')">一键打印</el-button>
          <!--<el-button type="danger" @click="printElecBill">电子票据打印</el-button>-->
          <button id="webPrintBtn" v-print="'#printDom'" style="display: none;">web打印</button>
        </template>
      </avue-form>
    </div>
    <el-dialog
      title="电子票据"
      :visible.sync="pdfDialogFlag"
      width="50%"
      @closed="handlePdfClose"
      append-to-body
    >
      <iframe width="100%" height="700" :src="printPdfUrl"></iframe>
    </el-dialog>
    <!-- web打印布局 -->
    <div style="display: none;">
      <div id="printDom" v-if="webPrintData">
        <div class="content">
          <div class="top">
            <!-- 客户 -->
            <div id="customer">{{ webPrintData.householdName }}</div>
            <!-- 日期 -->
            <div id="date">{{ webPrintData.payTime }}</div>
            <!-- 项目名称 -->
            <div id="project-name">{{ webPrintData.communityName }}</div>
            <!-- 结算方式 -->
            <div id="settlement-way">{{ webPrintData.payType }}</div>
          </div>
          <div class="table">
            <!-- 摘要 -->
            <div id="table-summary" class="flex">{{ webPrintData.printRemark }}</div>
            <!-- 详情列表 -->
            <div
              class="table-row"
              v-for="item in webPrintData.feePayDetailPrintList"
              :key="item.feeSort"
            >
              <div class="col-1">{{ item.feeSort }}</div>
              <div class="col-2">{{ item.payTime }}</div>
              <div class="col-3">{{ item.shouldAmount }}</div>
              <div class="col-4">{{ item.delayAmount }}</div>
              <div class="col-5">{{ item.payAmount }}</div>
            </div>
            <!-- 收款合计 -->
            <div id="table-sum">{{ webPrintData.totalPayAmountStr }}</div>
          </div>
          <!-- 收款说明 -->
          <div id="remark">{{ webPrintData.payRemark }}</div>
          <div class="bottom">
            <!-- 开票人 -->
            <div id="drawer">{{ webPrintData.cashier }}</div>
            <!-- 打印时间 -->
            <div id="time">{{ webPrintData.time }}</div>
            <!-- 二维码 -->
            <img
              v-show="webPrintData.communityGroup == 1"
              id="qrcode"
              src="data:image/png;base64,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"
            />
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {
  billPrintPerv,
  billPrintSave,
  checkPayBillNo,
  billPrint,
  getPrintInfo,
} from '@/api/charge/index';
import payChargePrintPreOption from './printdialog-option';
import urlSettings from '@/config/url-settings.js';
export default {
  data() {
    return {
      printPdfUrl: '',
      pdfDialogFlag: false,
      payChargePrintPreShowDialogFlag: false,
      payChargePrintPreForm: {},
      payChargePrintPreOption: payChargePrintPreOption,
      invoiceNo: '',
      printTimes: '',
      payBillNo: '',
      printFlag: true,
      systemFlag: 'windows',
      webPrintData: null,
    };
  },
  created() {
    this.initSystemInfo();
  },
  methods: {
    initSystemInfo() {
      const userAgent = navigator.userAgent;
      if (userAgent.indexOf('X11') !== -1 || userAgent.indexOf('Linux') !== -1) {
        this.systemFlag = 'linux';
      } else {
        this.systemFlag = 'windows';
      }
    },
    getWebPrintData() {
      getPrintInfo({
        payBillNo: this.payBillNo,
      }).then(({ data }) => {
        data.time = this.dayjs(new Date()).format('HH:mm'); // 补充时间字段
        this.webPrintData = data;
      });
    },
    openPayChargePrintPreDialog(payBillNo) {
      this.payBillNo = payBillNo;
      billPrintPerv({ payBillNo: payBillNo }).then(({ data }) => {
        this.payChargePrintPreForm = data;
        this.invoiceNo = data.invoiceNo;
        // var text = this.findObject(this.payChargePrintPreOption.column, 'invoiceNo');
        // if (this.invoiceNo) {
        //   text.disabled = true;
        // } else {
        //   text.disabled = false;
        // }
        this.printTimes = data.printTimes;
      });
      this.payChargePrintPreShowDialogFlag = true;
      if (this.systemFlag == 'linux') {
        this.getWebPrintData();
      }
    },
    saveF5() {
      this.$emit('saveF5');
    },
    //打印保存
    printSave(form, done) {
      this.$refs.payChargePrintPreFormRef.validate((valid) => {
        if (valid) {
          billPrintSave(form).then(
            () => {
              this.$message.success('操作成功!');
              // var text = this.findObject(this.payChargePrintPreOption.column, 'invoiceNo');
              // text.disabled = true;
              done();

              this.$emit('saveF5');
            },
            (error) => {
              done();
              console.log(error);
            }
          );
        }
      });
    },
    resetPrintForm() {
      this.payChargePrintPreShowDialogFlag = false;
      setTimeout(() => {
        this.payChargePrintPreShowDialogFlag = true;
      });
    },
    //打印
    print(type) {
      //打印开关 避免重复提交
      if (!this.printFlag) {
        return;
      }
      this.printFlag = false;
      this.$refs.payChargePrintPreFormRef.validate((valid) => {
        if (valid) {
          checkPayBillNo(this.payChargePrintPreForm).then(
            () => {
              //打印更新数据
              billPrint(this.payChargePrintPreForm).then(
                () => {
                  //票据号未被使用过，打开cpt页面
                  if (type == 'fast') {
                    this.openPrintWindow('fast');
                  } else {
                    this.openPrintWindow('rule');
                  }

                  this.printTimes++;
                  this.resetPrintForm();
                },
                (error) => {
                  console.log(error);
                  this.resetPrintForm();
                }
              );
            },
            (error) => {
              this.printFlag = true;
              this.resetPrintForm();
              done();
              console.log(error);
            }
          );
        } else {
          this.printFlag = true;
        }
      });
    },
    //电子票据打印
    printElecBill() {
      this.$refs.payChargePrintPreFormRef.validate((valid) => {
        if (valid) {
          checkPayBillNo(this.payChargePrintPreForm).then(
            () => {
              //打印更新数据
              billPrint(this.payChargePrintPreForm).then(
                ({ data }) => {
                  this.pdfDialogFlag = true;
                  this.printPdfUrl = location.origin + '/pdfjs/web/viewer.html?file=' + data;
                  debugger;
                },
                (error) => {
                  console.log(error);
                }
              );
            },
            (error) => {
              done();
              console.log(error);
            }
          );
        }
      });
    },
    //打开cpt页面
    openPrintWindow(type) {
      //打印次数
      let printTimes = this.printTimes + 1;
      //票据号
      let payBillNo = this.payBillNo;
      if (this.systemFlag == 'linux') {
        // this.webPrintData.time = this.dayjs(new Date()).format('HH:mm'); // 这个更新一放开打印就报错，原因不详
        document.getElementById('webPrintBtn').click();
        this.printFlag = true;
      } else {
        //跳转帆软html处理页面地址 并把票据号传到页面上
        let path = '';
        if (type == 'fast') {
          if (printTimes > '0') {
            this.$message({
              message: '已打印[' + printTimes + ']次',
              type: 'warning',
            });
            setTimeout(() => {
              this.printFlag = true;
            }, 1000);
          } else {
            this.printFlag = true;
          }
          // path = urlSettings.VUE_APP_BASE_REPORT_URL.split('ReportServer?')[0]  +'html/printbill.html?payBillNo='  + payBillNo + '&reportUrl='+ urlSettings.VUE_APP_REPORT_ENVIRONMENT;
          path = 'http://localhost:8075/WebReport/ReportServer?reportlet=newbill2.cpt&op=write';
          path =
            urlSettings.VUE_APP_BASE_REPORT_URL +
            urlSettings.VUE_APP_ENVIRONMENT +
            '/fastNewbill.cpt&op=write&payBillNo=' +
            payBillNo;
          window.open(
            path,
            'newindow',
            'height=600,width=1100,top=100,left=100,toolbar=no,' +
              'menubar=no,scrollbars=no,resizable=no,location=no,status=no,z-look=yes'
          );
        } else {
          path =
            urlSettings.VUE_APP_BASE_REPORT_URL.split('ReportServer?')[0] +
            'html/printbill.html?payBillNo=' +
            payBillNo +
            '&reportUrl=' +
            urlSettings.VUE_APP_REPORT_ENVIRONMENT;
          if (printTimes > '0') {
            this.$message({
              message: '已打印[' + printTimes + ']次',
              type: 'warning',
            });
            setTimeout(() => {
              this.printFlag = true;
              window.open(path);
            }, 1000);
          } else {
            this.printFlag = true;
            window.open(path);
          }
        }
      }

      //票据号
      // let path = urlSettings.BASE_REPORT_URL + cptName + '&op=write&payBillNo=' + payBillNo;

      // 不再让用户点击确定 直接展示已打印多少次
    },
    handleClose() {
      this.$refs.payChargePrintPreFormRef.resetForm();
    },
    handlePdfClose() {
      this.$refs.payChargePrintPreFormRef.resetForm();
      this.payChargePrintPreShowDialogFlag = false;
      this.printPdfUrl = '';
    },
  },
};
</script>

<style lang="scss" scoped>
#printDom {
  box-sizing: border-box;
  width: 240mm;
  height: 140mm;
  padding-left: 28mm;
  padding-top: 5mm;
  font-size: 4mm;

  .flex {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .content {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .top {
    position: absolute;
    left: 12mm;
    top: 28mm;
    width: 173mm;
    height: 12mm;
  }

  #customer {
    position: absolute;
    left: 13mm;
    top: 2mm;
  }

  #date {
    position: absolute;
    left: 87mm;
    top: 2mm;
  }

  #project-name {
    position: absolute;
    left: 20mm;
    top: 7.5mm;
  }

  #settlement-way {
    position: absolute;
    left: 95mm;
    top: 7.5mm;
  }

  .table {
    position: absolute;
    left: 12mm;
    top: 51mm;
    height: 38mm;
  }

  #table-summary {
    position: absolute;
    left: 0mm;
    top: 0mm;
    width: 50mm;
    height: 32mm;
  }

  .table-row {
    margin-left: 50mm;
    height: 6.5mm;
    display: flex;
    align-items: center;
    text-align: center;
  }

  .col-1 {
    width: 40mm;
  }

  .col-2 {
    width: 38mm;
  }

  .col-3 {
    width: 23mm;
  }

  .col-4 {
    width: 23mm;
  }

  .col-5 {
    width: 23mm;
  }

  #table-sum {
    position: absolute;
    left: 29mm;
    top: 36mm;
    width: 140mm;
    height: 5mm;
  }

  #remark {
    position: absolute;
    left: 37mm;
    top: 92mm;
    width: 148mm;
    height: 10mm;
  }

  .bottom {
    position: absolute;
    left: 13mm;
    top: 112mm;
    width: 173mm;
    height: 38mm;
  }

  #drawer {
    position: absolute;
    left: 14mm;
    top: 0mm;
  }

  #time {
    position: absolute;
    left: 163mm;
    top: 0mm;
  }

  #qrcode {
    position: absolute;
    left: 117mm;
    top: 5mm;
    width: 25mm;
    height: 25mm;
  }
}
</style>
